export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_pl.ad6b8bb7568ceb62.json"